import React from "react";
import { Link } from "react-router-dom";
import OtherPlatforms from "../OtherPlatforms";
import ReleaseNotes from "../ReleaseNotes";
import ReleaseSummary from "../ReleaseSummary";
import DownloadButton from "../UI/DownloadButton";
import { IVersion } from "../../utils/fetchers/types";
import { downloadButtonText } from "../../utils/helpers";
import { getDownloadPageUrl } from "../../routes/clientUrls";

import styles from './LastVersion.module.css'

type TLastVersion = {
  client: string,
  data: IVersion;
}

const LastVersion: React.FC<TLastVersion> = ({ client, data }) => {
  const { releaseNotes, platforms, version, summary } = data;
  const { platform, fileName } = platforms[0];
    
  
  return (
    <div className={styles.wrapper}>
      <div className={styles.hero}>
        <h1 className={styles.title}>
          Download the latest version
          <span className={styles.versionNumber}>
            &nbsp;{version}&nbsp;
            <br className={styles.showBr} />
          </span>
          of Velox Radiology Viewer
        </h1>
        <div className={styles.downloadArea}>
          <div className={styles.buttonWrap}>
            <Link to={getDownloadPageUrl(fileName)}>
              <DownloadButton
                variant="primary"
                size='lg'
                text={downloadButtonText(client, platform)}
              />
            </Link>
            <div className={styles.required}>Required Windows 7, 8.1, 10, 11</div>
          </div>
          {platforms.length > 1 &&
            <div className={styles.otherPlatformsWrapper}>
              <OtherPlatforms
                version={version}
                client={client}
                platforms={platforms.slice(1)}
              />
            </div>
          }
        </div>
      </div>
      {summary &&
        <div className={styles.summaryWrapper}>
          <ReleaseSummary summary={summary} />
        </div>
      }
      <div className={styles.releaseNotesWrapper}>
        <ReleaseNotes releaseNotes={releaseNotes} expanded twoColumns />
      </div>
    </div>
  );
};

export default LastVersion;